export const FMT_DATE_READABLE = 'MMM DD, YYYY';
export const FMT_DATE_SHORT = 'MM/DD/YYYY';
export const FMT_DATE_TIME = 'MMM DD, YYYY [at] hh:mm a';

export const FMTS_ISO = [
  'YYYY-MM-DD HH:mm:ssZ',
  'YYYY-MM-DD HH:mm:ss.SSSSZ',
];
